import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import Swal from 'sweetalert2';
import { OndemandSocketService } from 'src/app/services/ondemand-socket.service';

@Component({
  selector: 'app-next-appointment-ondemand',
  templateUrl: './next-appointment-ondemand.component.html',
  styleUrls: ['./next-appointment-ondemand.component.css']
})
export class NextAppointmentOndemandComponent implements OnInit {

  @Input() tiempoEspera: any = {}
  private intervalId: any; // Guarda el ID del intervalo para limpiarlo después



  salirFilaForm: FormGroup;
  cancelReason: any = [];
  modalActual: string | null = null;



  consultaOndemand: any = {};
  constructor(
    private router: Router,
    private _schedule: ScheduleService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private ondemandSocketService: OndemandSocketService,
  ) {
    this.salirFilaForm = this.fb.group({
      paciente: [null, Validators.required],
      id_ondemand: [null, Validators.required],
      reason: ['', Validators.required]
    });
  }
  usuario: any;

  popoverColor: string = '';

  options_bool: boolean = false;

  fechaTexto: string = '';

  cancel_reason: string = '';
  data_selected: any = {};          //resumen del consulta
  minutosEspera: any;

  messajeCard: string = '';
  isLoadingExitFila: boolean = false;
  isLoading: boolean = false;

  ngOnInit() {
    this.usuario = new EncriptacionService().getUserInfo();

    if (this.usuario.typ_id === 2 && this.tiempoEspera.onWaitlist === true) {
      this.postListUsersWaitList();

      this.ondemandSocketService.onDoctorDisponible().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onDoctorNoDisponible().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onDoctorFinalizaConsulta().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onActualizaFila().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
    }
        this.setCancelMessages();

    // Formatear el texto de la fecha y tiempo de espera
  }

  redondearTiempo(tiempo: number): string {
    const tiempoRedondeado = Math.round(tiempo);

    if (tiempoRedondeado > 60) {
      return '+60';
    }

    return `${Math.max(tiempoRedondeado, 5)}`;
  }

  setMensajeCard(){

    if (this.tiempoEspera.consulta.sta_id == 116) {
      this.messajeCard = '¡Es tu turno! Ingresa a la sala de espera para ser atendido.';
    } else if (this.tiempoEspera.data.tiempoEsperaTotal <= 15 && (this.tiempoEspera.consulta.sta_id == 114 || this.tiempoEspera.consulta.sta_id == 120)) {
      this.messajeCard = '¡Buena noticia! Serás atendido en los próximos minutos. Tu consulta está cerca.';
    } else if (this.tiempoEspera.data.tiempoEsperaTotal > 15 && this.tiempoEspera.data.tiempoEsperaTotal <= 45 && ( this.tiempoEspera.consulta.sta_id == 114 || this.tiempoEspera.consulta.sta_id == 120)) {
      this.messajeCard = 'Nuestros médicos te atenderán en los próximos minutos. Estamos trabajando para brindarte la mejor atención.';
    }else if (this.tiempoEspera.data.tiempoEsperaTotal > 45 && this.tiempoEspera.consulta.sta_id == 114) {
      this.messajeCard = 'Parece que hay una gran cantidad de pacientes en espera. No te preocupes, serás notificado cuando sea tu turno.';
    }

    if(this.tiempoEspera.consulta.sta_id == 114 || this.tiempoEspera.consulta.sta_id == 120){
      this.options_bool = true;
    }
  }



  postListUsersWaitList() {
    this.isLoading = true;
    this._schedule.postListUsersWaitList(this.usuario._id, this.usuario.typ_id)
      .then((response: any) => {
        //console.log('Respuesta del servicio:', response);
       
        if(response !== undefined){
       
          this.tiempoEspera = response;
          this.consultaOndemand = response.consulta || {};
       
          this.cdRef.detectChanges();
   
          this.popoverColor = '#2F7586'; // Porque es ondemand
   
          const fecha = this.tiempoEspera?.consulta?.fechaFormat || 'hoy';
 
          const minutosEspera = this.redondearTiempo(this.tiempoEspera.data.tiempoEspera || 0);
   
          if (this.tiempoEspera.consulta.sta_id != 116) {
            this.fechaTexto = `Hoy ${fecha} / ${minutosEspera} minutos restantes`;
          } else {
            this.fechaTexto = `Hoy ${fecha}`;
          }
   
          this.setMensajeCard();
          this.isLoading = false;
        }
 
      })
      .catch((error: any) => {
        console.error('Error al obtener la lista de espera:', error);
      });
  }

  goLobby = () => {

    if (this.tiempoEspera && this.tiempoEspera.consulta.med_con_id == null) {
      let url = `fila-ondemand/${this.tiempoEspera.consulta.tel_doc_od_id}/${this.tiempoEspera.consulta.tel_doc_od_id}`;
      this.router.navigate([url]);
    } else if (this.tiempoEspera && this.tiempoEspera.consulta.tel_doc_od_id && this.tiempoEspera.consulta.med_con_id != null) {
      let url = `salaespera/${this.tiempoEspera.consulta.tel_doc_app_boo_id}/${this.tiempoEspera.consulta.tel_doc_app_boo_id}/${this.tiempoEspera.consulta.med_con_id}`;
      this.router.navigate([url]);
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Consulta no disponible',
        text: 'No hay una consulta ondemand disponible en este momento.',
        timer: 3000
      });
    }
  }

  ngOnDestroy(): void {
    // Limpia el intervalo cuando se destruya el componente
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }



  confirmarCancelAppoOD() {
    this._schedule.postCancelWaitList(
      this.usuario._id,
      this.tiempoEspera.consulta.tel_doc_od_id,
      this.cancel_reason
    )
      .then(data => {
        // console.log("Reserva cancelada:", data);
        Swal.fire({
          allowOutsideClick: false,
          html:
            '<i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
            '<h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;">Haz salido de la fila de espera exitosamente</h1> <br>' +
            '<p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>',
          showConfirmButton: false,
        });

        setTimeout(() => window.location.reload(), 2000);
      })
      .catch(error => console.log("Error cancelando:", error));
  }

  mostrarModal(tipo: string) {
    // Muestra el mensaje de carga
    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
                      <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
                      <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                          Espere por favor...
                      </h1>
                   </div>`,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading(); // Muestra el spinner de carga
      }
    });

    this.salirFilaForm.patchValue({
      paciente: this.usuario._id,
      id_ondemand: this.tiempoEspera.consulta.tel_doc_od_id
    });

    // Llamada al servicio para obtener los motivos de cancelación
    this._schedule.getListarCancelReason("ONDEMAND")
      .then((response: any) => {
        this.cancelReason = response;
        // console.log(this.cancelReason);

        // Cierra el mensaje de carga y abre el modal
        Swal.close();
        this.modalActual = tipo;
        document.body.classList.add("modal-open"); // Bloquea el scroll
      })
      .catch((error: any) => {
        console.error("Error al obtener los motivos de cancelación:", error);

        // Cierra el mensaje de carga y muestra una alerta de error
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar los motivos de cancelación. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      });
  }

  cerrarModal() {
    this.modalActual = null;
    document.body.classList.remove("modal-open"); // Reactiva el scroll
  }

  abrirConfirmacionSinDevolucion() {
    this.modalActual = 'confirmarSinDevolucion';
  }

  salirDeFila() {
    const reasonId = this.salirFilaForm.value.reason;
    const pacienteId = this.usuario._id;
    const idOndemand = this.tiempoEspera.consulta.tel_doc_od_id;

    this.isLoadingExitFila = true;

    this._schedule.postCancelWaitList(pacienteId, idOndemand, reasonId)
      .then(() => {
        this.modalActual = null;
        document.body.classList.remove("modal-open");

        this.isLoadingExitFila = false;

        Swal.fire({
          allowOutsideClick: false,
          html: `<i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> 
                     <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;"> 
                         Has salido de la fila exitosamente.
                     </h1>`,
          showConfirmButton: false,
          timer: 2000
        });

        setTimeout(() => {
          Swal.close();
          this.router.navigateByUrl('/dashboard').then(() => {
            window.location.reload();
          });
        }, 2000);
      })
      .catch(error => {
        console.error("Error al cancelar la espera:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo procesar la solicitud. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      });
  }

  reservaHora() {
    var url = "reserva-hora/";
    this.router.navigate([url]);
  }

cancelMsg1: string = '';
  cancelMsg2: string = '';
    private setCancelMessages(): void {
    const isSnabb = this.tiempoEspera?.consulta?.is_snabb;
    const canRefunded = this.tiempoEspera?.consulta?.can_refunded;
    // console.log(this.tiempoEspera);
    

    // console.log('RAW is_snabb:', this.tiempoEspera?.consulta?.is_snabb, typeof this.tiempoEspera?.consulta?.is_snabb);

    // DEBUG (borra cuando confirmes)
    // console.log('SNABB:', isSnabb, 'REFUND:', canRefunded, this.data?.consulta);

    if (isSnabb) {
      this.cancelMsg1 = 'Al confirmar la anulación, se perderá la reserva de la hora y se iniciará el proceso de reembolso del pago realizado.';
      this.cancelMsg2 = 'Para más información, revisa el detalle de reembolso disponible en nuestros términos y condiciones.';
      return;
    }

    if (!isSnabb) {
      this.cancelMsg1 = 'Al salir de la fila no se descontará tu consulta del convenio';
      this.cancelMsg2 = '';
      return;
    }

    this.cancelMsg1 = 'Al hacerlo, perderás tu reserva actual y deberás solicitar una nueva hora si deseas reagendar.';
    this.cancelMsg2 = '';
  }
}
